module.exports = __webpack_public_path__ + "static/assets/b9d74bc117f9b8fcb8634b02afab37e9.svg";